import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { translate } from '../../Services/translation';
import { googleAnalytics } from '../../Services/googleAnalytics';
import { setAdvancedMarkerIsOpen, setAdvancedMarkerId, setAutocompletePlace } from '../../Actions/ResellerMapList.action';
import { scrollToMap } from '../DealerLocationContainer';

export const GoogleMapAutocomplete = (props) => {
  const dispatch = useDispatch();
  const googleMapState = useSelector((state) => state.resellermaplist);
  const places = useMapsLibrary('places');
  const [autocompleteService, setAutocompleteService] = useState(null); 
  const [placesService, setPlacesService] = useState(null);
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!places || !inputRef.current) return;

    var countries = props.restrictedcountry.split(',')
    const options = {
      componentRestrictions: { country: countries },
      fields: ['geometry', 'name', 'formatted_address']
    };
    setAutocompleteService(new places.AutocompleteService());
    setPlacesService(new places.PlacesService(document.createElement('div')));
    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places, inputRef]);

  const onPlaceSelect = useCallback((place) => {
      if (place && place.geometry) {
        const { location } = place.geometry;

        dispatch(setAdvancedMarkerIsOpen(false));
        dispatch(setAdvancedMarkerId(null));
        dispatch(setAutocompletePlace(place));
        props.update({ lat: location.lat(), longt: location.lng() });

        googleAnalytics({
          event: 'dealerLocatorSearchUpdate',
          localization: 'search',
        });        
        scrollToMap();
      }
    },
    [dispatch, googleMapState.advancedMarkerIsOpen, props, scrollToMap]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener('place_changed', () => {
      dispatch(setAutocompletePlace(placeAutocomplete.getPlace()));
      onPlaceSelect(placeAutocomplete.getPlace());
    });
  }, [dispatch, onPlaceSelect]);

  const handleAutoSearch = (e) => {
    if (e.key === 'Enter') {
      const autocompleteQuery = e.target.value;
  
      if (autocompleteService && placesService && autocompleteQuery) {
        autocompleteService.getPlacePredictions(
          { input: autocompleteQuery, componentRestrictions: { country: props.restrictedcountry.split(',') } },
          (places, status) => {
            if (status === window.google.maps.places.PlacesServiceStatus.OK && places.length > 0) {
              const place = places[0];
    
              placesService.getDetails(
                { placeId: place.place_id, fields: ['geometry', 'name', 'formatted_address'] },
                (placeInfo, placeStatus) => {
                  if (placeStatus === window.google.maps.places.PlacesServiceStatus.OK && placeInfo.geometry) {
                    onPlaceSelect(placeInfo)
                  }
                }
              );
            }
          }
        );
      }
    };
  };

  return (
    <div className="input-box">
        <div className="search-input">
            <input
                ref={inputRef} 
                type="text" 
                id="place-autocomplete-input"
                placeholder={translate('dealerlocator.searchboxplaceholder')}
                onKeyPress={handleAutoSearch}
                aria-label={translate('dealerlocator.searchboxplaceholder')}
                />
            <svg>
                <use href="/ui/images/sprites/brenderup.svg#search-icon"></use>
            </svg>
        </div>
    </div >
  );
};